import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/logo-pm.svg'; 
import shapelogo from '../../assets/shap.svg';
import { 
  LayoutDashboard, 
  Users, 
  FolderArchive, 
  CalendarDays, 
  BarChart3, 
  Settings, 
  UserRoundCog,
  Headset,
  LifeBuoy,
  HelpingHand,
  Briefcase
} from 'lucide-react';
const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = user?.roleId === 1;
  // تقييد خاص: لو المستخدم عنده allowedPage محددة، يشوف الصفحة دي بس في القائمة
  const allowedPage = user?.allowedPage ? user.allowedPage.toLowerCase() : null;

  const menuItems = [
    { title: 'لوحة التحكم', icon: <LayoutDashboard size={20} />, path: '/dashboard', isAdminOnly: true },
    { title: 'الإدارات', icon: <Users size={20} />, path: '/departments', isAdminOnly: true },
    { title: 'أرشيف الإدارة', icon: <FolderArchive size={20} />, path: '/archivadmin', isAdminOnly: true },
    { title: 'الخطة', icon: <CalendarDays size={20} />, path: '/planadmin', isAdminOnly: true },
    { title: 'التقارير', icon: <BarChart3 size={20} />, path: '/reports', isAdminOnly: true },
    { title: 'الموظفين', icon: <Briefcase size={20} />, path: '/employees', isAdminOnly: true },
    { title: 'المستخدمين', icon: <UserRoundCog size={20} />, path: '/users', isAdminOnly: true },
    { title: 'الإعدادات', icon: <Settings size={20} />, path: '/settings', isAdminOnly: true },
    
  ];

  // الوجهة الافتراضية عند الضغط على اللوجو
  const logoDestination = allowedPage ? allowedPage : (isAdmin ? '/dashboard' : '/SupportdSec1');

  return (
    <>
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 lg:hidden" 
          onClick={toggleSidebar}
        ></div>
      )}

      <aside className={`fixed top-0 right-0 h-full font-ibm bg-white transition-all duration-300 z-50 border-l border-gray-100 
        ${isOpen ? 'w-64 translate-x-0' : 'w-20 lg:translate-x-0 translate-x-full'}`}>
        
        <div className="p-4 flex flex-col h-full">
          <div className="flex items-center justify-center mb-10 w-full">
            <Link to={logoDestination} className="w-full flex justify-center items-center h-16">
              {isOpen ? (
                <img src={logo} alt="Pro Manager" className="w-[85%] object-contain transition-all duration-300" />
              ) : (
                <img src={shapelogo} alt="Icon" className="w-[85%] object-contain transition-all duration-300" />
              )}
            </Link>
          </div>

          <nav className="space-y-2">
            {menuItems.map((item, index) => {
              // لو المستخدم مقيّد بصفحة واحدة، متعرضش غيرها في القائمة
              if (allowedPage) {
                if (item.path.toLowerCase() !== allowedPage) return null;
              } else {
                if (item.isAdminOnly && !isAdmin) return null;
                if (item.isUser && isAdmin) return null;
              }

              const isActive = location.pathname.toLowerCase() === item.path.toLowerCase();

              return (
                <Link 
                  key={index} 
                  to={item.path}
                  className={`flex items-center p-3 rounded-2xl cursor-pointer transition-all duration-200 no-underline ${
                    isActive 
                    ? 'bg-blue-50 text-[#263238] font-bold' 
                    : 'text-gray-400 hover:bg-gray-50'
                  } ${isOpen ? 'justify-start px-4' : 'justify-center'}`}
                >
                  <span className="shrink-0">{item.icon}</span>
                  {isOpen && (
                    <span className="mr-3 flex-1 text-right font-medium whitespace-nowrap">
                      {item.title}
                    </span>
                  )}
                </Link>
              );
            })}
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;